import React from "react";
import "./myexperience.css";

const MyExperience = () => {
  const data = [
    {
      company_name: "Mitt Arv",
      work_details: {
        work1: "• Leading Front end Application along with Backend.",
        work2: "• Implementing new features using flutter and node.js.",
        work3: "• Designing Database Schema, Rest api's.",
        work4: "• Task Management using Jira",
        work5: "• Code Reviewing",
        work6: "• Deploying Application on Playstore.",
      },
      duration: "July 2023 - Present",
      position: "Software Development Engineer",
    },
    {
      company_name: "Mitt Arv",
      work_details: {
        work1: "• Leading Front end Application along with Backend.",
        work2: "• Implementing new features using flutter and node.js.",
        work3: "• Designing Database Schema, Rest api's.",
        work4: "• Task Management using Jira",
        work5: "• Code Reviewing",
      },
      duration: "April 2022 - June 2023",
      position: "Software Engineer Intern",
    },
    {
      company_name: "Humming Sparrow Digital Solution",
      work_details: {
        work1: "• Designed Web Pages using React.js and css.",
        work2: "• Integrated rest api's with front end",
        work3: "• Resolved bugs and implemented new Functionality",
      },
      duration: "September 2021 - March 2022",
      position: "React.js Developer Intern",
    },
    {
      company_name: "Nemessis Consultant LLP",
      work_details: {
        work1:
          "• Worked as full stack mern developer . Implement some new features and resolve bugs.",
        work2:
          "• Functionality and design new web pages suing react.js , html and css ",
        work3: "• Integrate api with front end ",
      },
      duration: "January 2022  - March 2022",
      position: "React and Node.js Developer",
    },
    {
      company_name: "Listiee.com",
      work_details: {
        work1:
          "• Designed and developed efficient, secure, and scalable web applications using the MERN stack ",
        work2: "• Designed Web Pages using React.js and Sass ",
        work3: "• Designed database schema and rest api's for front end ",
      },
      duration: "June 2021 - July 2021",
      position: "Full Stack Developer Intern",
    },
  ];
  
  return (
    <div className="my_experience">
      <p className="about_me__heading">My Experience</p>
      <p className="small_para_about_skill">
        Here is a quick summary of my most recent experiences:
      </p>
      <div className="display_experience_card">
        {data.map((item) => {
          return (
            <div className="experience_card">
              <p className="company_name">{item.company_name}</p>
              <div className="work_details">
                <p className="position">{item.position}</p>
                {Object.keys(item.work_details).map((key) => {
                  return <p>{item.work_details[key]}</p>;
                })}
              </div>
              <div className="duration">
                <p>{item.duration}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyExperience;
